module.exports = __webpack_public_path__ + "img/device_cover_c.8f7e9932.svg";